import { createFileRoute, redirect } from "@tanstack/react-router";

// Profile was merged into Settings.
export const Route = createFileRoute("/_market/profile/")({
	beforeLoad: () => {
		throw redirect({ to: "/settings", replace: true });
	},
});
